// extracted by mini-css-extract-plugin
export var content = "TagCard-module--content--1e418";
export var explicit = "TagCard-module--explicit--36c8a";
export var footer = "TagCard-module--footer--b0448";
export var image = "TagCard-module--image--6c4e6";
export var imageOuter = "TagCard-module--image-outer--7c186";
export var imageTabs = "TagCard-module--image-tabs--20075";
export var imageTabsItem = "TagCard-module--image-tabs-item--20245";
export var imageWrapper = "TagCard-module--image-wrapper--300d7";
export var isExplicit = "TagCard-module--is-explicit--ff412";
export var isExplicitInner = "TagCard-module--is-explicit-inner--dc690";
export var isExplicitWarning = "TagCard-module--is-explicit-warning--61924";
export var link = "TagCard-module--link--e31b0";
export var outer = "TagCard-module--outer--096ac";
export var subtitle = "TagCard-module--subtitle--5c36e";
export var tagsWrapper = "TagCard-module--tags-wrapper--625ed";
export var tagsWrapperList = "TagCard-module--tags-wrapper-list--2b099";
export var tagsWrapperSlot = "TagCard-module--tags-wrapper-slot--9d67b";
export var title = "TagCard-module--title--03a96";
export var withFooter = "TagCard-module--with-footer--dfdbe";